import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import InncreaseCampaignBudgetForm from "./InncreaseCampaignBudgetForm";
import Select from "react-select";
import "./CreateCampaignTemplate.css";
import "./nameCampaign.css";

// ✅ Validation Schema using Yup
const validationSchema = Yup.object().shape({
  campaignBudget: Yup.number()
    .min(1, "Budget must be greater than zero")
    .required("Budget is required"),
  campaignBidStrategy: Yup.object().required("Bid Strategy is required"),
  //   budgetScheduling:  Yup.string(),
  // startDate: Yup.date().required("Start date is required"),
  // startTime: Yup.string().required("Start time is required"),
  // endDate: Yup.date().required("End date is required"),
  // endTime: Yup.string().required("End time is required"),
  // bidAmount: Yup.number()
  //   .min(1, "Amount must be greater than zero")
  //   .required("Amount is required"),

  budgetScheduling: Yup.boolean(), // Assuming it's a boolean field

  startDate: Yup.date().when("budgetScheduling", {
    is: true,
    then: (schema) => schema.required("Start date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  startTime: Yup.string().when("budgetScheduling", {
    is: true,
    then: (schema) => schema.required("Start time is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  endDate: Yup.date().when("budgetScheduling", {
    is: true,
    then: (schema) => schema.required("End date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  endTime: Yup.string().when("budgetScheduling", {
    is: true,
    then: (schema) => schema.required("End time is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  bidStrategy: Yup.string().when("budgetScheduling", {
    is: true,
    then: (schema) => schema.required("Bid Strategy is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  bidAmount: Yup.number().when("budgetScheduling", {
    is: true,
    then: (schema) =>
      schema
        .min(1, "Amount must be greater than zero")
        .required("Amount is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

const budgetOptions = [243500, 280500, 400000];

const CampaignBudget = ({
  setIsFormTwoValid,
  setFormTwoValue,
  formTwoValue,
  budgetTypes,
  reactSelectStyles,
}) => {
  const [budgetType, setBudgetType] = useState(budgetTypes[0]);
  const [selectedBudget, setSelectedBudget] = useState(null);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const budgetOptions = [243500, 280500, 400000];
  const [showBudgetIncreaseForm, setShowBudgetIncreaseForm] = useState(false);
  const handleBudgetIncreaseCheck = (e, setFieldValue) => {
    setFieldValue("budgetScheduling", e.target.checked);
    if (e.target.checked) {
      setShowBudgetIncreaseForm(true);
    } else {
      setShowBudgetIncreaseForm(false);
      setFieldValue("startDate", "");
      setFieldValue("startTime", "");
      setFieldValue("endDate", "");
      setFieldValue("endTime", "");
      setFieldValue("bidStrategy", "");
      setFieldValue("bidAmount", "");
    }
  };

  return (
    <div className="campaign-budget-container h-[90vh] overflow-scroll pt-5 pb-40">
      <div
        className="create-form-item"
        style={{ flexDirection: "column", alignItems: "baseline", gap: "5px" }}
      >
        <div className="title" style={{ fontWeight: "bold" }}>
          Advantage Campaign Budget
        </div>

        <p className="description">
          Distribute your budget across ad sets to get more results. You can
          control spending for each ad set.
        </p>
      </div>
      <Formik
        initialValues={{
          budgetType: formTwoValue.budgetType || budgetType || "",
          campaignBudget: formTwoValue.campaignBudget || "",
          campaignBidStrategy: formTwoValue.campaignBidStrategy || "",
          budgetScheduling:
            formTwoValue.budgetScheduling || showBudgetIncreaseForm || false,
          bidStrategy: formTwoValue.bidStrategy || "",
          startDate: formTwoValue.startDate || "",
          startTime: formTwoValue.startTime || "",
          endDate: formTwoValue.endDate || "",
          endTime: formTwoValue.endTime || "",
          bidAmount: formTwoValue.bidAmount || "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          console.log("Form Submitted", values);
        }}
      >
        {({ errors, touched, isValid, dirty, values, setFieldValue }) => {
          if (dirty) {
            setIsFormTwoValid(isValid && dirty);
            setFormTwoValue(values);
          }

          return (
            <Form>
              <div className="create-form-item">
                <div className="toggle-type-buttons">
                  {budgetTypes.map((type) => (
                    <button
                      key={type}
                      className={`toggle-button f-12 ${
                        budgetType === type ? "active" : ""
                      }`}
                      onClick={() => setBudgetType(type)}
                    >
                      {type}
                    </button>
                  ))}
                </div>
                <div
                  style={{ display: "flex", gap: "20px", alignItems: "center" }}
                >
                  <div style={{ fontWeight: "bold" }} className="f-14">
                    Campaign Budget
                  </div>
                  <div className="input-container">
                    {/* <input type="text" placeholder="Enter Budget" /> */}
                    <Field
                      type="number"
                      name="campaignBudget"
                      placeholder="Enter Budget"
                    />
                    <ErrorMessage
                      name="campaignBudget"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </div>
              </div>
              <div className="budget-section">
                <div className="budget-options">
                  {budgetOptions.map((option) => (
                    <button
                      key={option}
                      className={`option-button display-container-1 ${
                        selectedBudget === option ? "selected" : ""
                      }`}
                      onClick={() => setSelectedBudget(option)}
                    >
                      <span className="value-1">{`₹ ${option.toLocaleString()}`}</span>
                      <span className="checkmark-1">&#10003;</span>
                    </button>
                  ))}
                </div>
                <p className="info-text">*Based on last spend</p>
              </div>
              <div className="create-form-item">
                <p className="spend-info f-12">
                  You’ll spend an average of ₹200.00 per day. Your maximum daily
                  spend is ₹350.00 and your maximum weekly spend is ₹1,400.00.
                </p>
              </div>

              <div className="create-form-item">
                <div className="f-bold f-14">Campaign Bid Strategy</div>
                <div className="bid-container">
                  {/* <Select
            placeholder="Select"
            options={[
              { label: "Highest Volume", value: "Highest" },
              { label: "Lowest Volume", value: "Lowest" },
            ]}
            styles={reactSelectStyles}
            // value={adType}
            // onChange={handleAdTypeChange}
          />{" "}

 */}
                  <Select
                    styles={reactSelectStyles}
                    placeholder="Select"
                    options={[
                      { label: "Highest Volume", value: "Highest" },
                      { label: "Lowest Volume", value: "Lowest" },
                    ]}
                    value={values.campaignBidStrategy}
                    onChange={(option) =>
                      setFieldValue("campaignBidStrategy", option)
                    }
                  />{" "}
                  <ErrorMessage
                    name="campaignBidStrategy"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>
              {showMoreOptions && (
                <div
                  className="create-form-item"
                  style={{ alignItems: "unset" }}
                >
                  {" "}
                  <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Budget Scheduling
                  </div>
                  <div className="input-container-check">
                    {/* <input type="checkbox" onChange={handleBudgetIncreaseCheck} /> */}
                    <Field
                      type="checkbox"
                      name="budgetScheduling"
                      onChange={(e) => {
                        handleBudgetIncreaseCheck(e, setFieldValue);
                      }}
                    />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <p style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                        Schedule Budget Increases
                      </p>
                      <p className="spend-info" style={{ marginTop: "0px" }}>
                        Increase your budget during specific days or times.
                      </p>
                      {showBudgetIncreaseForm && (
                        <InncreaseCampaignBudgetForm />
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className="create-form-item">
                <p
                  onClick={() => setShowMoreOptions((prev) => !prev)}
                  style={{ color: "blue", cursor: "pointer" }}
                >
                  + {showMoreOptions ? "hide" : "Show"} more options
                </p>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default CampaignBudget;
